import _regeneratorRuntime from "@babel/runtime/regenerator";
import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import { QueuedJobsHandler } from "../QueuedJobsHandler";
export var ErrorCartTypes;

(function (ErrorCartTypes) {
  ErrorCartTypes[ErrorCartTypes["SET_CART_ITEM"] = 0] = "SET_CART_ITEM";
})(ErrorCartTypes || (ErrorCartTypes = {}));

export var CartQueuedJobs =
/*#__PURE__*/
function (_QueuedJobsHandler) {
  _inherits(CartQueuedJobs, _QueuedJobsHandler);

  function CartQueuedJobs(repository, networkManager) {
    var _this;

    _classCallCheck(this, CartQueuedJobs);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CartQueuedJobs).call(this));
    _this.setCartItem =
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var checkout, _ref2, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              checkout = _this.repository.getCheckout();

              if (!checkout) {
                _context.next = 8;
                break;
              }

              _context.next = 4;
              return _this.networkManager.setCartItem(checkout);

            case 4:
              _ref2 = _context.sent;
              data = _ref2.data;
              error = _ref2.error;

              if (error && _this.onErrorListener) {
                _this.onErrorListener(error, ErrorCartTypes.SET_CART_ITEM);
              } else if (data) {
                _this.repository.setCheckout(_objectSpread({}, checkout, {
                  lines: data.lines,
                  promoCodeDiscount: data.promoCodeDiscount
                }));
              }

            case 8:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    _this.repository = repository;
    _this.networkManager = networkManager;
    return _this;
  }

  return CartQueuedJobs;
}(QueuedJobsHandler);